import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';

const SingleImageUploader = ({ 
  onFileSelected, 
  onRemove,
  currentImage, 
  buttonLabel = 'Select Image' 
}) => {
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      setError('Please select a valid image file (JPEG, PNG, GIF, or WEBP)');
      return;
    }

    // Validate file size (max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      setError('Image size should be less than 5MB');
      return;
    }

    // Create a local preview URL
    const previewUrl = URL.createObjectURL(file);
    setError(null);
    
    // Pass the file and preview URL to parent component
    onFileSelected({
      file,
      previewUrl,
      fileName: file.name
    });
    
    // Clear the input value so the same file can be selected again if needed
    event.target.value = '';
  };

  return (
    <Box>
      {currentImage ? (
        <Box sx={{ mt: 2, mb: 2, position: 'relative', maxWidth: 300 }}>
          <img 
            src={currentImage} 
            alt="Image Preview" 
            style={{ width: '100%', height: 'auto', borderRadius: '4px' }} 
          />
          <Button 
            variant="contained" 
            color="error" 
            size="small"
            sx={{ position: 'absolute', top: 8, right: 8 }}
            onClick={onRemove}
          >
            Remove
          </Button>
        </Box>
      ) : (
        <Box sx={{ my: 1 }}>
          <input
            type="file"
            accept="image/*"
            id="single-image-upload"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <label htmlFor="single-image-upload">
            <Button
              variant="outlined"
              component="span"
            >
              {buttonLabel}
            </Button>
          </label>
          
          {error && (
            <Typography color="error" variant="caption" display="block" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default SingleImageUploader; 